// extracted by mini-css-extract-plugin
export default {"faq":"content_faq__w0+Go","services":"content_services__Ikh-t"};